import React, { useState } from "react";
import { Link } from "react-router-dom";
import Industries from "../../images/aktcorp/Tools-16.jpg";
import Fire from "../../images/aktcorp/burn.jpg";

export default function IndustryCategories() {
  const [bgColor, setBgColor] = useState("transparent");

  return (
    <div>
      {/* ............. Section One .............. */}
      <section className="w-full bg-[#0C2340] text-white">
        <div className="w-full px-4 py-3">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-0 items-stretch">
            {/* Left Section - Fire Components */}
            <div className="bg-white text-[#0C2340] p-4 flex flex-col justify-center md:max-h-[260px] w-full 
                        rounded-l-lg lg:rounded-l-lg lg:rounded-r-none">
              <h2 className="text-2xl md:text-3xl font-bold mb-4">
                FIRE-RATED COMPONENTS & THERMAL SOLUTIONS
              </h2>
              <p className="text-base md:text-lg leading-relaxed">
                We offer high-quality fire-rated components and thermal appliances designed to meet stringent safety standards. Engineered for durability and performance, our solutions provide reliable protection against extreme heat and fire, ensuring safety and efficiency in critical environments.
              </p>
            </div>

            {/* Right Section - Image with Hover Zoom Effect */}
            <div className="relative w-full overflow-hidden group rounded-r-lg">
              <img
                src={Fire}
                alt="Industry categories"
                className="w-full h-full object-cover md:max-h-[260px] rounded-r-lg transition-transform duration-500 ease-in-out group-hover:scale-110"
              />
            </div>
          </div>
        </div>
      </section>

      {/* ............. Section Two - Fixed Height Issues .............. */}
      <section className="w-full bg-[#0C2340] text-white">
        <div className="mx-auto px-4 py-8 md:py-0 lg:py-0">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-0 items-stretch">
            {/* Left Box - Image with Hover Zoom Effect */}
            <div className="lg:col-span-8 flex items-stretch md:max-h-[450px] overflow-hidden group rounded-l-lg">
              <img
                src={Industries}
                alt="Industry categories"
                className="w-full h-full rounded-l-lg object-cover transition-transform duration-500 ease-in-out group-hover:scale-110"
              />
            </div>

            {/* Right Box - Text */}
            <div className="lg:col-span-4 bg-white text-[#0C2340] p-6 rounded-r-lg flex flex-col justify-center">
              <h2 className="text-2xl md:text-3xl font-bold mb-4">
                EXPLORE OUR INDUSTRY CATEGORIES
              </h2>
              <p className="text-base md:text-lg leading-relaxed text-justify">
                We deliver specialized solutions tailored to the unique demands of diverse industries. Whether it’s construction, automotive, healthcare, electronics, or beyond, our innovative products and services are designed to enhance efficiency, elevate performance, and ensure safety across every sector. With a steadfast commitment to quality and progress, we empower industries to thrive in a constantly evolving world.
              </p>
              <Link to="/division/explore-divisions" className="mt-3">
                <button
                  className="px-3 py-2 border-2 border-[#0C2340] text-[#0C2340] hover:text-white font-semibold rounded-lg transition duration-300"
                  style={{ backgroundColor: bgColor }}
                  onMouseEnter={() => setBgColor("#1B365D")}
                  onMouseLeave={() => setBgColor("white")}
                >
                  EXPLORE OUR DIVISION
                </button>
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
